// lib
import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, Route } from "react-router-dom";

// src
import { loginAndKeepPath } from "actions/user/thunks";

const LoggedRoute = ({ component: Component, ...rest }) => {
  const { isLogged } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const render = () => {
    if (isLogged) return <Component />;
    dispatch(loginAndKeepPath(location.pathname, history));
    return null;
  };

  return <Route render={render} {...rest} />;
};

LoggedRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
};

export default LoggedRoute;
